import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', () => {
  initRolodexHero();

  let resizeTimer;
  let lastWidth = window.innerWidth;
  window.addEventListener('resize', () => {
    if (window.innerWidth === lastWidth) return;

    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      lastWidth = window.innerWidth;
      ScrollTrigger.getAll().forEach(trigger => trigger.kill(true));
      gsap.killTweensOf('*');
      initRolodexHero();
      ScrollTrigger.refresh();
    }, 250);
  });
});

function getCardSize() {
  const maxWidth = Math.min(window.innerWidth * 0.75, 580);
  const maxHeight = Math.min(window.innerHeight * 0.75, 580);

  const heightLimit =
    window.innerHeight < 700 ? window.innerHeight * 0.5 : maxHeight;

  let width = maxWidth;
  let height = (width * 10) / 16;

  if (height > heightLimit) {
    height = heightLimit;
    width = (height * 16) / 10;
  }

  return { width, height };
}

function initRolodexHero() {
  const isMobile = window.innerWidth < 768;
  const isHeightSmall = window.innerHeight < 768;
  const titles = gsap.utils.toArray('.rolodex-hero__card-title');
  const baseCards = gsap.utils.toArray('.rolodex-hero__card-new');
  // const videoCard = document.querySelector('.rolodex-hero__section--video-new');
  // const videoControls = videoCard?.querySelector('.controls-overlay');
  // const videoContainer = videoCard?.querySelector('.rolodex-hero__container');
  const loading = document.querySelector('.rolodex-loading');
  const loadingIcon = document.querySelector('.rolodex-loading svg');
  // const videoPlayerContainer = videoCard?.querySelector(
  //   '.rolodex-hero__video-container'
  // );
  // const videoPlayer = videoCard?.querySelector('video.rolodex-hero__video');
  const stackedCards = document.querySelector('.rolodex-hero__stacked-cards');
  const pinHeight = document.querySelector('.rolodex-hero__pin-height');
  const header = document.querySelector('header');
  const topRightFixedElement = document.querySelector(
    '.fixed-topright-element'
  );
  const titleArea = document.querySelector('.rolodex-hero__title-area');
  // const scrollDownButton = document.querySelector('.rolodex-hero_scroll-down');
  const vh = window.innerHeight;

  if (
    !baseCards.length ||
    !titles.length ||
    // !videoCard ||
    !stackedCards ||
    !pinHeight ||
    !header
  )
    return;

  const cards = [...baseCards];
  const totalSections = cards.length + 1;
  const totalScrollSections = totalSections * 0.75;
  const lastCardIndex = cards.length - 1;

  cards.forEach(card => {
    card.classList.remove('initial-fallback');
  });

  ScrollTrigger.clearScrollMemory('manual');
  window.scrollTo(0, 0);
  setTimeout(() => {
    if (!loading || !loadingIcon) return;

    gsap.to(loadingIcon, {
      width: '100%',
      height: '100%',
      borderRadius: 0,
      opacity: 0,
      onComplete: () => loading.remove(),
    });
  }, 2000);

  gsap.set(titleArea, { zIndex: '999' });

  gsap.set(titles, {
    opacity: 0,
    y: 20,
    backdropFilter: 'blur(4px)',
    borderRadius: '50px',
    paddingTop: '24px',
    paddingBottom: '24px',
  });
  gsap.set(titles[0], { opacity: 1, y: 0 });

  const { width: cardWidth, height: cardHeight } = getCardSize();

  cards.forEach((card, index) => {
    gsap.set(card, {
      width: cardWidth,
      height: cardHeight,
      maxWidth: cardWidth,
      maxHeight: cardHeight,
      y: isMobile || isHeightSmall ? index * 30 : index * 50,
      scale: 1 - index * 0.1,
      rotationX: cards[cards.length - 1]
        ? cards.length + 3 - index
        : cards.length + 2 - index,
      zIndex: cards.length - index,
      transformStyle: 'preserve-3d',
    });
  });

  // gsap.set(videoContainer, {
  //   width: cardWidth,
  //   height: cardHeight,
  //   maxWidth: cardWidth,
  // });

  updateStackedCardsWidth(stackedCards);

  // SETTINGS — tweak how long video stays after expansion
  const extraScrollAfterVideo = 1.5; // how many extra viewports to stay pinned
  // const rotationPhase = 0.4; // scroll fraction for rotation
  // const expansionPhase = 0.25; // scroll fraction for expansion
  // const holdPhase = 0.5; // scroll fraction for holding expanded video

  // Increase pin height
  pinHeight.style.height = `${vh}px`;

  header.classList.add('is-sticky');

  // gsap.set(videoControls, { opacity: 0, zIndex: '-1' });
  // gsap.set(scrollDownButton, { opacity: 0 });
  // gsap.set(videoPlayer, {
  //   width: '100%',
  //   height: '100%',
  //   marginBottom: 0,
  //   objectFit: 'cover',
  // });
  // gsap.set(videoPlayerContainer, { width: '100%', height: '100%' });

  // const videoIndex = cards.indexOf(videoCard);
  // const videoStart = videoIndex / totalScrollSections;

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: '.rolodex-hero__wrapper',
      start: 'top top',
      end: () => `+=${vh * (totalScrollSections + extraScrollAfterVideo)}`,
      scrub: 0.1,
      pin: '.rolodex-hero__pin-height',
      anticipatePin: 1,
    },
  });

  // Card transitions
  cards.forEach((card, index) => {
    const startTime = index / totalScrollSections;
    const duration = 1 / totalScrollSections;

    if (index !== lastCardIndex) {
      tl.to(
        card,
        {
          y: -vh * 0.5,
          opacity: 0,
          scale: 0.5,
          ease: 'none',
          keyframes: [
            {
              rotationX: cards.length + 2 - index,
              duration: duration * 0.4,
            },
            {
              rotationX: 32,
              duration: duration * 0.75,
              ease: 'power2.inOut',
            },
          ],
        },
        startTime
      );

      const titleIndex = cards.indexOf(card) + 1;

      if (titleIndex !== -1) {
        if (titleIndex > 0) {
          tl.to(
            titles[titleIndex - 1],
            {
              opacity: 0,
              y: -50,
              duration: duration * 0.6,
              ease: 'power2.in',
              overwrite: 'auto',
            },
            startTime
          );
        }

        tl.to(
          titles[titleIndex],
          {
            opacity: titleIndex === 0 ? 0 : 1,
            y: -50,
            duration: duration * 0.4,
            rotationX: titleIndex === 0 ? 0 : 16,
            ease: 'power2.out',
            overwrite: 'auto',
          },
          titleIndex === 0 ? startTime : startTime + duration * 0.6
        );
      }
    }
    // else if (card === videoCard) {
    //   tl.to(
    //     titles[titles.length - 1],
    //     {
    //       opacity: 0,
    //       duration: duration * 0.5,
    //       overwrite: 'auto',
    //     },
    //     startTime
    //   );
    // }

    for (let i = index + 1; i < cards.length; i++) {
      const newPos = i - index - 1;
      tl.to(
        cards[i],
        {
          y: isMobile || isHeightSmall ? newPos * 30 : newPos * 50,
          scale: 1 - newPos * 0.1,
          duration,
          ease: 'power2.out',
          overwrite: 'auto',
        },
        startTime + 0.01
      );
    }
  });

  // tl.to(pinHeight, { backgroundColor: 'black' }, videoStart * 0.7);
  // tl.to(
  //   topRightFixedElement,
  //   { opacity: 0, zIndex: '-1', ease: 'power2.inOut' },
  //   videoStart
  // );
  // tl.to(titleArea, { zIndex: '-1' }, videoStart * 0.1);

  // const expandedWidth = Math.min(window.innerWidth * 0.85, 1280);
  // const expandedHeight = Math.min((expandedWidth * 720) / 1280, 720);

  // const rotateStart = videoStart * 0.7;

  // tl.to(videoCard, { rotationX: 0, ease: 'power2.inOut' }, rotateStart);

  // tl.to(
  //   videoCard,
  //   {
  //     width: expandedWidth,
  //     height: expandedHeight,
  //     maxWidth: expandedWidth,
  //     maxHeight: expandedHeight,
  //     ease: 'power2.inOut',
  //     onStart: () => {
  //       videoPlayer.style.display = 'flex';
  //     },
  //     onComplete: () => {
  //       videoControls.style.opacity = '1';
  //       videoControls.style.zIndex = '1';
  //       scrollDownButton.style.opacity = '1';
  //       videoPlayer.play().catch(e => {
  //         console.warn('Autoplay blocked or failed:', e);
  //       });
  //     },
  //   },
  //   rotateStart + rotationPhase
  // );

  // tl.to(
  //   videoContainer,
  //   {
  //     width: expandedWidth,
  //     height: expandedHeight,
  //     maxWidth: expandedWidth,
  //     maxHeight: expandedHeight,
  //     borderRadius: isMobile ? '20px' : '',
  //     ease: 'power2.inOut',
  //   },
  //   rotateStart + rotationPhase
  // );

  // tl.to(
  //   stackedCards,
  //   {
  //     marginBottom: isMobile || isHeightSmall ? '' : '0px',
  //     ease: 'power2.inOut',
  //   },
  //   rotateStart + rotationPhase
  // );

  // tl.to(
  //   {},
  //   { duration: holdPhase },
  //   rotateStart + rotationPhase + expansionPhase
  // );

  // ScrollTriggers for video state changes
  ScrollTrigger.create({
    trigger: '.rolodex-hero__wrapper',
    start: 'top top',
    end: () => `+=${vh * (totalScrollSections + extraScrollAfterVideo)}`,
    scrub: true,
    onUpdate: self => {
      const sectionProgress = self.progress * totalScrollSections;
      const activeIndex = Math.floor(sectionProgress);
      if (activeIndex < lastCardIndex - 1) {
        // videoPlayer.style.marginBottom = '0';
        // videoControls.style.opacity = '0';
        // videoControls.style.zIndex = '-1';
        // scrollDownButton.style.opacity = '0';
        // videoPlayer.style.objectFit = 'cover';
        // videoPlayer?.pause();
      }
    },
    onEnter: () => {
      header.style.opacity = '0';
      setTimeout(() => {
        header.style.zIndex = '-1';
      }, 300);
    },
    onLeaveBack: () => {
      setTimeout(() => {
        topRightFixedElement.classList.remove('fixed-topright-element--adjust');
      }, 300);
      header.style.opacity = '1';
      header.style.zIndex = '9999999';
    },
  });

  ScrollTrigger.config({ ignoreMobileResize: true });
}

function updateStackedCardsWidth(stackedCards) {
  const isMobile = window.innerWidth < 768;
  const isHeightSmall = window.innerHeight < 768;
  gsap.set(stackedCards, {
    width: isMobile ? '100%' : isHeightSmall ? '30%' : '60%',
    minWidth: !isMobile && isHeightSmall && '400px',
    height: !isHeightSmall && '100%',
    transformStyle: 'preserve-3d',
    transformPerspective: 1000,
    maxHeight: isMobile ? '30vh' : '',
    marginTop: isMobile ? '' : isHeightSmall ? '64px' : '0px',
    marginBottom: isMobile ? '' : '200px',
    alignItems: 'center',
  });
}

